module.exports = __webpack_public_path__ + "img/63exp.d0978006.jpg";